import axios from 'axios';
import { ElMessage } from 'element-plus';
import { useUserStore } from '@/stores/user';

const instance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 请求拦截器
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('geo_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截器
instance.interceptors.response.use(
    (response) => {
        // 文件下载（blob）直接放行原始响应
        if (response.config.responseType === 'blob') return response;
        const { code, message, data } = response.data;
        if (code === 0) {
            return data;
        }
        ElMessage.error(message || '请求失败');
        return Promise.reject(new Error(message));
    },
    (error) => {
        if (error.response) {
            const { status, data } = error.response;
            // 登录接口本身的 401（密码错误/账号禁用/锁定等）是会话未建立的业务报错，
            // 不能按"会话过期"处理——否则 logout + 整页跳转 /login 看起来就像刷了一下页面，错误提示也被冲掉
            const isLoginRequest = (error.config?.url || '').includes('/auth/login');
            if (status === 401 && !isLoginRequest) {
                const userStore = useUserStore();
                userStore.logout();
                window.location.href = '/login';
            } else if (status === 403) {
                ElMessage.error({ message: '无权限执行此操作', grouping: true });
            } else {
                ElMessage.error({ message: data?.message || '服务器错误', grouping: true });
            }
        } else {
            ElMessage.error('网络连接失败');
        }
        return Promise.reject(error);
    }
);

export default instance;
